import React from 'react'

const ProfileViewGraph = () => {
  return (
    <div className="col-lg-8">
  <div className="user-profile-card">
    <h4 className="user-profile-card-title">Your Profile Views</h4>
    <div className="row">
      <div className="col-lg-12">
        <div id="chart" style={{ minHeight: 395 }}>
          <div
            id="apexchartsqpcwsz6d"
            className="apexcharts-canvas apexchartsqpcwsz6d apexcharts-theme-light"
            style={{ width: 486, height: 380 }}
          >
            <svg
      id="SvgjsSvg1006"
      width={486}
      height={380}
      version="1.1"
      className="apexcharts-svg apexcharts-zoomable hovering-zoom"
      transform="translate(0, 0)"
      style={{ background: "transparent" }}
    >
              <g
                id="SvgjsG1008"
                className="apexcharts-inner apexcharts-graphical"
                transform="translate(45.54725646972656, 30)"
              >
                <defs id="SvgjsDefs1007">
                  <clipPath id="gridRectMaskqpcwsz6d">
                    <rect
                      id="SvgjsRect1014"
                      width="426.7784013748169"
                      height="317.42666718101503"
                      x={-4}
                      y={-2}
                      rx={0}
                      ry={0}
                      opacity={1}
                      strokeWidth={0}
                      stroke="none"
                      strokeDasharray={0}
                      fill="#fff"
                    />
                  </clipPath>
                  <clipPath id="forecastMaskqpcwsz6d" />
                  <clipPath id="nonForecastMaskqpcwsz6d" />
                  <clipPath id="gridRectMarkerMaskqpcwsz6d">
                    <rect
                      id="SvgjsRect1015"
                      width="422.7784013748169"
                      height="317.42666718101503"
                      x={-2}
                      y={-2}
                      rx={0}
                      ry={0}
                      opacity={1}
                      strokeWidth={0}
                      stroke="none"
                      strokeDasharray={0}
                      fill="#fff"
                    />
                  </clipPath>
                  <linearGradient
                    id="SvgjsLinearGradient1020"
                    x1={0}
                    y1={0}
                    x2={0}
                    y2={1}
                  >
                    <stop
                      id="SvgjsStop1021"
                      stopOpacity="0.65"
                      stopColor="rgba(60,101,245,0.65)"
                      offset={0}
                    />
                    <stop
                      id="SvgjsStop1022"
                      stopOpacity="0.5"
                      stopColor="rgba(158,178,250,0.5)"
                      offset={1}
                    />
                    <stop
                      id="SvgjsStop1023"
                      stopOpacity="0.5"
                      stopColor="rgba(158,178,250,0.5)"
                      offset={1}
                    />
                  </linearGradient>
                </defs>
                <line
                  id="SvgjsLine1013"
                  x1="208.88920068740848"
                  y1={0}
                  x2="208.88920068740848"
                  y2="313.42666718101503"
                  stroke="#b6b6b6"
                  strokeDasharray={3}
                  strokeLinecap="butt"
                  className="apexcharts-xcrosshairs"
                  x="208.88920068740848"
                  y={0}
                  width={1}
                  height="313.42666718101503"
                  fill="#b1b9c4"
                  filter="none"
                  fillOpacity="0.9"
                  strokeWidth={1}
                />
                <g
                  id="SvgjsG1026"
                  className="apexcharts-xaxis"
                  transform="translate(0, 0)"
                >
                  <g
                    id="SvgjsG1027"
                    className="apexcharts-xaxis-texts-g"
                    transform="translate(0, -4)"
                  >
                    <text
                      id="SvgjsText1029"
                      fontFamily="Helvetica, Arial, sans-serif"
                      x={0}
                      y="342.42666718101503"
                      textAnchor="middle"
                      dominantBaseline="auto"
                      fontSize="12px"
                      fontWeight={400}
                      fill="#373d3f"
                      className="apexcharts-text apexcharts-xaxis-label "
                      style={{ fontFamily: "Helvetica, Arial, sans-serif" }}
                    >
                      <tspan id="SvgjsTspan1030">Jan</tspan>
                      <title>Jan</title>
                    </text>
                    <text
                      id="SvgjsText1032"
                      fontFamily="Helvetica, Arial, sans-serif"
                      x="52.34730017185211"
                      y="342.42666718101503"
                      textAnchor="middle"
                      dominantBaseline="auto"
                      fontSize="12px"
                      fontWeight={400}
                      fill="#373d3f"
                      className="apexcharts-text apexcharts-xaxis-label "
                      style={{ fontFamily: "Helvetica, Arial, sans-serif" }}
                    >
                      <tspan id="SvgjsTspan1033">Feb</tspan>
                      <title>Feb</title>
                    </text>
                    <text
                      id="SvgjsText1035"
                      fontFamily="Helvetica, Arial, sans-serif"
                      x="104.69460034370422"
                      y="342.42666718101503"
                      textAnchor="middle"
                      dominantBaseline="auto"
                      fontSize="12px"
                      fontWeight={400}
                      fill="#373d3f"
                      className="apexcharts-text apexcharts-xaxis-label "
                      style={{ fontFamily: "Helvetica, Arial, sans-serif" }}
                    >
                      <tspan id="SvgjsTspan1036">Mar</tspan>
                      <title>Mar</title>
                    </text>
                    <text
                      id="SvgjsText1038"
                      fontFamily="Helvetica, Arial, sans-serif"
                      x="157.04190051555634"
                      y="342.42666718101503"
                      textAnchor="middle"
                      dominantBaseline="auto"
                      fontSize="12px"
                      fontWeight={400}
                      fill="#373d3f"
                      className="apexcharts-text apexcharts-xaxis-label "
                      style={{ fontFamily: "Helvetica, Arial, sans-serif" }}
                    >
                      <tspan id="SvgjsTspan1039">Apr</tspan>
                      <title>Apr</title>
                    </text>
                    <text
                      id="SvgjsText1041"
                      fontFamily="Helvetica, Arial, sans-serif"
                      x="209.38920068740845"
                      y="342.42666718101503"
                      textAnchor="middle"
                      dominantBaseline="auto"
                      fontSize="12px"
                      fontWeight={400}
                      fill="#373d3f"
                      className="apexcharts-text apexcharts-xaxis-label "
                      style={{ fontFamily: "Helvetica, Arial, sans-serif" }}
                    >
                      <tspan id="SvgjsTspan1042">May</tspan>
                      <title>May</title>
                    </text>
                    <text
                      id="SvgjsText1044"
                      fontFamily="Helvetica, Arial, sans-serif"
                      x="261.73650085926056"
                      y="342.42666718101503"
                      textAnchor="middle"
                      dominantBaseline="auto"
                      fontSize="12px"
                      fontWeight={400}
                      fill="#373d3f"
                      className="apexcharts-text apexcharts-xaxis-label "
                      style={{ fontFamily: "Helvetica, Arial, sans-serif" }}
                    >
                      <tspan id="SvgjsTspan1045">Jun</tspan>
                      <title>Jun</title>
                    </text>
                    <text
                      id="SvgjsText1047"
                      fontFamily="Helvetica, Arial, sans-serif"
                      x="314.08380103111267"
                      y="342.42666718101503"
                      textAnchor="middle"
                      dominantBaseline="auto"
                      fontSize="12px"
                      fontWeight={400}
                      fill="#373d3f"
                      className="apexcharts-text apexcharts-xaxis-label "
                      style={{ fontFamily: "Helvetica, Arial, sans-serif" }}
                    >
                      <tspan id="SvgjsTspan1048">Jul</tspan>
                      <title>Jul</title>
                    </text>
                    <text
                      id="SvgjsText1050"
                      fontFamily="Helvetica, Arial, sans-serif"
                      x="366.4311012029648"
                      y="342.42666718101503"
                      textAnchor="middle"
                      dominantBaseline="auto"
                      fontSize="12px"
                      fontWeight={400}
                      fill="#373d3f"
                      className="apexcharts-text apexcharts-xaxis-label "
                      style={{ fontFamily: "Helvetica, Arial, sans-serif" }}
                    >
                      <tspan id="SvgjsTspan1051">Aug</tspan>
                      <title>Aug</title>
                    </text>
                    <text
                      id="SvgjsText1053"
                      fontFamily="Helvetica, Arial, sans-serif"
                      x="418.7784013748169"
                      y="342.42666718101503"
                      textAnchor="middle"
                      dominantBaseline="auto"
                      fontSize="12px"
                      fontWeight={400}
                      fill="#373d3f"
                      className="apexcharts-text apexcharts-xaxis-label "
                      style={{ fontFamily: "Helvetica, Arial, sans-serif" }}
                    >
                      <tspan id="SvgjsTspan1054">Sep</tspan>
                      <title>Sep</title>
                    </text>
                  </g>
                  <line
                    id="SvgjsLine1055"
                    x1={0}
                    y1="314.42666718101503"
                    x2="418.7784013748169"
                    y2="314.42666718101503"
                    stroke="#e0e0e0"
                    strokeDasharray={0}
                    strokeWidth={1}
                    strokeLinecap="butt"
                  />
                </g>
                <g id="SvgjsG1076" className="apexcharts-grid">
                  <g
                    id="SvgjsG1077"
                    className="apexcharts-gridlines-horizontal"
                  >
                    <line
                      id="SvgjsLine1088"
                      x1={0}
                      y1={0}
                      x2="418.7784013748169"
                      y2={0}
                      stroke="#e0e0e0"
                      strokeDasharray={0}
                      strokeLinecap="butt"
                      className="apexcharts-gridline"
                    />
                    <line
                      id="SvgjsLine1089"
                      x1={0}
                      y1="62.68533343620301"
                      x2="418.7784013748169"
                      y2="62.68533343620301"
                      stroke="#e0e0e0"
                      strokeDasharray={0}
                      strokeLinecap="butt"
                      className="apexcharts-gridline"
                    />
                    <line
                      id="SvgjsLine1090"
                      x1={0}
                      y1="125.37066687240602"
                      x2="418.7784013748169"
                      y2="125.37066687240602"
                      stroke="#e0e0e0"
                      strokeDasharray={0}
                      strokeLinecap="butt"
                      className="apexcharts-gridline"
                    />
                    <line
                      id="SvgjsLine1091"
                      x1={0}
                      y1="188.05600030860904"
                      x2="418.7784013748169"
                      y2="188.05600030860904"
                      stroke="#e0e0e0"
                      strokeDasharray={0}
                      strokeLinecap="butt"
                      className="apexcharts-gridline"
                    />
                    <line
                      id="SvgjsLine1092"
                      x1={0}
                      y1="250.74133374481204"
                      x2="418.7784013748169"
                      y2="250.74133374481204"
                      stroke="#e0e0e0"
                      strokeDasharray={0}
                      strokeLinecap="butt"
                      className="apexcharts-gridline"
                    />
                    <line
                      id="SvgjsLine1093"
                      x1={0}
                      y1="313.42666718101503"
                      x2="418.7784013748169"
                      y2="313.42666718101503"
                      stroke="#e0e0e0"
                      strokeDasharray={0}
                      strokeLinecap="butt"
                      className="apexcharts-gridline"
                    />
                  </g>
                  <g
                    id="SvgjsG1078"
                    className="apexcharts-gridlines-vertical"
                  />
                  <line
                    id="SvgjsLine1079"
                    x1={0}
                    y1="314.42666718101503"
                    x2={0}
                    y2="320.42666718101503"
                    stroke="#e0e0e0"
                    strokeDasharray={0}
                    strokeLinecap="butt"
                    className="apexcharts-xaxis-tick"
                  />
                  <line
                    id="SvgjsLine1080"
                    x1="52.34730017185211"
                    y1="314.42666718101503"
                    x2="52.34730017185211"
                    y2="320.42666718101503"
                    stroke="#e0e0e0"
                    strokeDasharray={0}
                    strokeLinecap="butt"
                    className="apexcharts-xaxis-tick"
                  />
                  <line
                    id="SvgjsLine1081"
                    x1="104.69460034370422"
                    y1="314.42666718101503"
                    x2="104.69460034370422"
                    y2="320.42666718101503"
                    stroke="#e0e0e0"
                    strokeDasharray={0}
                    strokeLinecap="butt"
                    className="apexcharts-xaxis-tick"
                  />
                  <line
                    id="SvgjsLine1082"
                    x1="157.04190051555634"
                    y1="314.42666718101503"
                    x2="157.04190051555634"
                    y2="320.42666718101503"
                    stroke="#e0e0e0"
                    strokeDasharray={0}
                    strokeLinecap="butt"
                    className="apexcharts-xaxis-tick"
                  />
                  <line
                    id="SvgjsLine1083"
                    x1="209.38920068740845"
                    y1="314.42666718101503"
                    x2="209.38920068740845"
                    y2="320.42666718101503"
                    stroke="#e0e0e0"
                    strokeDasharray={0}
                    strokeLinecap="butt"
                    className="apexcharts-xaxis-tick"
                  />
                  <line
                    id="SvgjsLine1084"
                    x1="261.73650085926056"
                    y1="314.42666718101503"
                    x2="261.73650085926056"
                    y2="320.42666718101503"
                    stroke="#e0e0e0"
                    strokeDasharray={0}
                    strokeLinecap="butt"
                    className="apexcharts-xaxis-tick"
                  />
                  <line
                    id="SvgjsLine1085"
                    x1="314.08380103111267"
                    y1="314.42666718101503"
                    x2="314.08380103111267"
                    y2="320.42666718101503"
                    stroke="#e0e0e0"
                    strokeDasharray={0}
                    strokeLinecap="butt"
                    className="apexcharts-xaxis-tick"
                  />
                  <line
                    id="SvgjsLine1086"
                    x1="366.4311012029648"
                    y1="314.42666718101503"
                    x2="366.4311012029648"
                    y2="320.42666718101503"
                    stroke="#e0e0e0"
                    strokeDasharray={0}
                    strokeLinecap="butt"
                    className="apexcharts-xaxis-tick"
                  />
                  <line
                    id="SvgjsLine1087"
                    x1="418.7784013748169"
                    y1="314.42666718101503"
                    x2="418.7784013748169"
                    y2="320.42666718101503"
                    stroke="#e0e0e0"
                    strokeDasharray={0}
                    strokeLinecap="butt"
                    className="apexcharts-xaxis-tick"
                  />
                  <line
                    id="SvgjsLine1095"
                    x1={0}
                    y1="313.42666718101503"
                    x2="418.7784013748169"
                    y2="313.42666718101503"
                    stroke="transparent"
                    strokeDasharray={0}
                    strokeLinecap="butt"
                  />
                  <line
                    id="SvgjsLine1094"
                    x1={0}
                    y1={1}
                    x2={0}
                    y2="313.42666718101503"
                    stroke="transparent"
                    strokeDasharray={0}
                    strokeLinecap="butt"
                  />
                </g>
                <g
                  id="SvgjsG1016"
                  className="apexcharts-area-series apexcharts-plot-series"
                >
                  <g
  id="SvgjsG1017"
  className="apexcharts-series"
  seriesname="Views"
  data-longestseries="true"
  rel={1}
  data-realindex={0}
>
                    <path
                      id="SvgjsPath1024"
                      d="M0 313.42666718101503L0 266.41266710386276C18.321555060148242 266.41266710386276 34.02574511170388 297.7553338219643 52.34730017185212 297.7553338219643C70.66885523200037 297.7553338219643 86.373045283556 219.39866702671054 104.69460034370424 219.39866702671054C123.01615540385247 219.39866702671054 138.7203454554081 235.07000038576126 157.04190051555634 235.07000038576126C175.3634555757046 235.07000038576126 191.06764562726022 156.71333359050755 209.38920068740848 156.71333359050755C227.7107557475567 156.71333359050755 243.41494579911233 109.69933351335527 261.73650085926056 109.69933351335527C280.0580559194088 109.69933351335527 295.76224597096444 188.05600030860904 314.08380103111267 188.05600030860904C332.4053560912609 188.05600030860904 348.10954614281655 62.685333436202995 366.4311012029648 62.685333436202995C384.75265626311307 62.685333436202995 400.4568463146687 219.39866702671054 418.77840137481695 219.39866702671054C418.77840137481695 219.39866702671054 418.77840137481695 219.39866702671054 418.77840137481695 313.42666718101503M418.77840137481695 219.39866702671054C418.77840137481695 219.39866702671054 418.77840137481695 219.39866702671054 418.77840137481695 219.39866702671054 "
                      fill="url(#SvgjsLinearGradient1020)"
                      fillOpacity={1}
                      strokeOpacity={1}
                      strokeLinecap="butt"
                      strokeWidth={0}
                      strokeDasharray={0}
                      className="apexcharts-area"
                      index={0}
                      clipPath="url(#gridRectMaskqpcwsz6d)"
                      pathto="M 0 313.42666718101503L 0 266.41266710386276C 18.321555060148242 266.41266710386276 34.02574511170388 297.7553338219643 52.34730017185212 297.7553338219643C 70.66885523200037 297.7553338219643 86.373045283556 219.39866702671054 104.69460034370424 219.39866702671054C 123.01615540385247 219.39866702671054 138.7203454554081 235.07000038576126 157.04190051555634 235.07000038576126C 175.3634555757046 235.07000038576126 191.06764562726022 156.71333359050755 209.38920068740848 156.71333359050755C 227.7107557475567 156.71333359050755 243.41494579911233 109.69933351335527 261.73650085926056 109.69933351335527C 280.0580559194088 109.69933351335527 295.76224597096444 188.05600030860904 314.08380103111267 188.05600030860904C 332.4053560912609 188.05600030860904 348.10954614281655 62.685333436202995 366.4311012029648 62.685333436202995C 384.75265626311307 62.685333436202995 400.4568463146687 219.39866702671054 418.77840137481695 219.39866702671054C 418.77840137481695 219.39866702671054 418.77840137481695 219.39866702671054 418.77840137481695 313.42666718101503M 418.77840137481695 219.39866702671054z"
                      pathfrom="M -1 501.4826674896241L -1 501.4826674896241L 52.34730017185212 501.4826674896241L 104.69460034370424 501.4826674896241L 157.04190051555634 501.4826674896241L 209.38920068740848 501.4826674896241L 261.73650085926056 501.4826674896241L 314.08380103111267 501.4826674896241L 366.4311012029648 501.4826674896241L 418.77840137481695 501.4826674896241"
                    />
                    <path
                      id="SvgjsPath1025"
                      d="M0 266.41266710386276C18.321555060148242 266.41266710386276 34.02574511170388 297.7553338219643 52.34730017185212 297.7553338219643C70.66885523200037 297.7553338219643 86.373045283556 219.39866702671054 104.69460034370424 219.39866702671054C123.01615540385245 219.39866702671054 138.7203454554081 235.07000038576126 157.04190051555634 235.07000038576126C175.3634555757046 235.07000038576126 191.06764562726022 156.71333359050755 209.38920068740848 156.71333359050755C227.7107557475567 156.71333359050755 243.41494579911233 109.69933351335527 261.73650085926056 109.69933351335527C280.0580559194088 109.69933351335527 295.76224597096444 188.05600030860904 314.08380103111267 188.05600030860904C332.4053560912609 188.05600030860904 348.10954614281655 62.685333436202995 366.4311012029648 62.685333436202995C384.75265626311307 62.685333436202995 400.4568463146687 219.39866702671054 418.77840137481695 219.39866702671054C418.77840137481695 219.39866702671054 418.77840137481695 219.39866702671054 418.77840137481695 219.39866702671054 "
                      fill="none"
                      fillOpacity={1}
                      stroke="rgba(60,101,245,0.85)"
                      strokeOpacity={1}
                      strokeLinecap="butt"
                      strokeWidth={4}
                      strokeDasharray={0}
                      className="apexcharts-area"
                      index={0}
                      clipPath="url(#gridRectMaskqpcwsz6d)"
                      pathto="M 0 266.41266710386276C 18.321555060148242 266.41266710386276 34.02574511170388 297.7553338219643 52.34730017185212 297.7553338219643C 70.66885523200037 297.7553338219643 86.373045283556 219.39866702671054 104.69460034370424 219.39866702671054C 123.01615540385247 219.39866702671054 138.7203454554081 235.07000038576126 157.04190051555634 235.07000038576126C 175.3634555757046 235.07000038576126 191.06764562726022 156.71333359050755 209.38920068740848 156.71333359050755C 227.7107557475567 156.71333359050755 243.41494579911233 109.69933351335527 261.73650085926056 109.69933351335527C 280.0580559194088 109.69933351335527 295.76224597096444 188.05600030860904 314.08380103111267 188.05600030860904C 332.4053560912609 188.05600030860904 348.10954614281655 62.685333436202995 366.4311012029648 62.685333436202995C 384.75265626311307 62.685333436202995 400.4568463146687 219.39866702671054 418.77840137481695 219.39866702671054"
                      pathfrom="M -1 501.4826674896241L -1 501.4826674896241L 52.34730017185212 501.4826674896241L 104.69460034370424 501.4826674896241L 157.04190051555634 501.4826674896241L 209.38920068740848 501.4826674896241L 261.73650085926056 501.4826674896241L 314.08380103111267 501.4826674896241L 366.4311012029648 501.4826674896241L 418.77840137481695 501.4826674896241"
                    />
                    <g
                       id="SvgjsG1018"
                       className="apexcharts-series-markers-wrap"
                       data-realindex={0}
                    >
                      <g className="apexcharts-series-markers">
                        <circle
                          id="SvgjsCircle1101"
                          r={0}
                          cx="209.38920068740848"
                          cy="156.71333359050755"
                          className="apexcharts-marker wrgr4mftv no-pointer-events"
                          stroke="#ffffff"
                          fill="#3c65f5"
                          fillOpacity={1}
                          strokeWidth={2}
                          strokeOpacity="0.9"
                          default-marker-size={0}
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="SvgjsG1019"
                    className="apexcharts-datalabels"
                    data-realindex={0}
                  />
                </g>
                <line
                  id="SvgjsLine1096"
                  x1={0}
                  y1={0}
                  x2="418.7784013748169"
                  y2={0}
                  stroke="#b6b6b6"
                  strokeDasharray={0}
                  strokeWidth={1}
                  strokeLinecap="butt"
                  className="apexcharts-ycrosshairs"
                />
                <line
                  id="SvgjsLine1097"
                  x1={0}
                  y1={0}
                  x2="418.7784013748169"
                  y2={0}
                  strokeDasharray={0}
                  strokeWidth={0}
                  strokeLinecap="butt"
                  className="apexcharts-ycrosshairs-hidden"
                />
                <g id="SvgjsG1098" className="apexcharts-yaxis-annotations" />
                <g id="SvgjsG1099" className="apexcharts-xaxis-annotations" />
                <g id="SvgjsG1100" className="apexcharts-point-annotations" />
                <rect
                  id="SvgjsRect1102"
                  width={0}
                  height={0}
                  x={0}
                  y={0}
                  rx={0}
                  ry={0}
                  opacity={1}
                  strokeWidth={0}
                  stroke="none"
                  strokeDasharray={0}
                  fill="#fefefe"
                  className="apexcharts-zoom-rect"
                />
                <rect
                  id="SvgjsRect1103"
                  width={0}
                  height={0}
                  x={0}
                  y={0}
                  rx={0}
                  ry={0}
                  opacity={1}
                  strokeWidth={0}
                  stroke="none"
                  strokeDasharray={0}
                  fill="#fefefe"
                  className="apexcharts-selection-rect"
                />
              </g>
              <rect
                id="SvgjsRect1012"
                width={0}
                height={0}
                x={0}
                y={0}
                rx={0}
                ry={0}
                opacity={1}
                strokeWidth={0}
                stroke="none"
                strokeDasharray={0}
                fill="#fefefe"
              />
              <g
                id="SvgjsG1056"
                className="apexcharts-yaxis"
                rel={0}
                transform="translate(15.547256469726562, 0)"
              >
                <g id="SvgjsG1057" className="apexcharts-yaxis-texts-g">
                  <text
                    id="SvgjsText1059"
                    fontFamily="Helvetica, Arial, sans-serif"
                    x={20}
                    y="31.5"
                    textAnchor="end"
                    dominantBaseline="auto"
                    fontSize="11px"
                    fontWeight={400}
                    fill="#373d3f"
                    className="apexcharts-text apexcharts-yaxis-label "
                    style={{ fontFamily: "Helvetica, Arial, sans-serif" }}
                  >
                    <tspan id="SvgjsTspan1060">320</tspan>
                    <title>320</title>
                  </text>
                  <text
                    id="SvgjsText1062"
                    fontFamily="Helvetica, Arial, sans-serif"
                    x={20}
                    y="94.18533343620301"
                    textAnchor="end"
                    dominantBaseline="auto"
                    fontSize="11px"
                    fontWeight={400}
                    fill="#373d3f"
                    className="apexcharts-text apexcharts-yaxis-label "
                    style={{ fontFamily: "Helvetica, Arial, sans-serif" }}
                  >
                    <tspan id="SvgjsTspan1063">280</tspan>
                    <title>280</title>
                  </text>
                  <text
                    id="SvgjsText1065"
                    fontFamily="Helvetica, Arial, sans-serif"
                    x={20}
                    y="156.87066687240602"
                    textAnchor="end"
                    dominantBaseline="auto"
                    fontSize="11px"
                    fontWeight={400}
                    fill="#373d3f"
                    className="apexcharts-text apexcharts-yaxis-label "
                    style={{ fontFamily: "Helvetica, Arial, sans-serif" }}
                  >
                    <tspan id="SvgjsTspan1066">240</tspan>
                    <title>240</title>
                  </text>
                  <text
                    id="SvgjsText1068"
                    fontFamily="Helvetica, Arial, sans-serif"
                    x={20}
                    y="219.55600030860904"
                    textAnchor="end"
                    dominantBaseline="auto"
                    fontSize="11px"
                    fontWeight={400}
                    fill="#373d3f"
                    className="apexcharts-text apexcharts-yaxis-label "
                    style={{ fontFamily: "Helvetica, Arial, sans-serif" }}
                  >
                    <tspan id="SvgjsTspan1069">200</tspan>
                    <title>200</title>
                  </text>
                  <text
                    id="SvgjsText1071"
                    fontFamily="Helvetica, Arial, sans-serif"
                    x={20}
                    y="282.24133374481204"
                    textAnchor="end"
                    dominantBaseline="auto"
                    fontSize="11px"
                    fontWeight={400}
                    fill="#373d3f"
                    className="apexcharts-text apexcharts-yaxis-label "
                    style={{ fontFamily: "Helvetica, Arial, sans-serif" }}
                  >
                    <tspan id="SvgjsTspan1072">160</tspan>
                    <title>160</title>
                  </text>
                  <text
                    id="SvgjsText1074"
                    fontFamily="Helvetica, Arial, sans-serif"
                    x={20}
                    y="344.92666718101503"
                    textAnchor="end"
                    dominantBaseline="auto"
                    fontSize="11px"
                    fontWeight={400}
                    fill="#373d3f"
                    className="apexcharts-text apexcharts-yaxis-label "
                    style={{ fontFamily: "Helvetica, Arial, sans-serif" }}
                  >
                    <tspan id="SvgjsTspan1075">120</tspan>
                    <title>120</title>
                  </text>
                </g>
              </g>
              <g id="SvgjsG1009" className="apexcharts-annotations" />
            </svg>
            <div className="apexcharts-legend" style={{ maxHeight: 190 }} />
            <div
              className="apexcharts-tooltip apexcharts-theme-light"
              style={{ left: "143.083px", top: "159.713px" }}
            >
              <div
                className="apexcharts-tooltip-title"
                style={{
                  fontFamily: "Helvetica, Arial, sans-serif",
                  fontSize: 12
                }}
              >
                May
              </div>
              <div
                className="apexcharts-tooltip-series-group apexcharts-active"
                style={{ order: 1, display: "flex" }}
              >
                <span
                  className="apexcharts-tooltip-marker"
                  style={{ backgroundColor: "rgb(60, 101, 245)" }}
                />
                <div
                  className="apexcharts-tooltip-text"
                  style={{
                    fontFamily: "Helvetica, Arial, sans-serif",
                    fontSize: 12
                  }}
                >
                  <div className="apexcharts-tooltip-y-group">
                    <span className="apexcharts-tooltip-text-y-label">
                      Views:{" "}
                    </span>
                    <span className="apexcharts-tooltip-text-y-value">220</span>
                  </div>
                  <div className="apexcharts-tooltip-goals-group">
                    <span className="apexcharts-tooltip-text-goals-label" />
                    <span className="apexcharts-tooltip-text-goals-value" />
                  </div>
                  <div className="apexcharts-tooltip-z-group">
                    <span className="apexcharts-tooltip-text-z-label" />
                    <span className="apexcharts-tooltip-text-z-value" />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="apexcharts-xaxistooltip apexcharts-xaxistooltip-bottom apexcharts-theme-light"
              style={{ left: "232.402px", top: "345.427px" }}
            >
              <div
                className="apexcharts-xaxistooltip-text"
                style={{
                  fontFamily: "Helvetica, Arial, sans-serif",
                  fontSize: 12,
                  minWidth: "21.5917px"
                }}
              >
                May
              </div>
            </div>
            <div className="apexcharts-yaxistooltip apexcharts-yaxistooltip-0 apexcharts-yaxistooltip-left apexcharts-theme-light">
              <div className="apexcharts-yaxistooltip-text" />
            </div>
            <div className="apexcharts-toolbar" style={{ top: 0, right: 3 }}>
              <div className="apexcharts-zoomin-icon" title="Zoom In">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
                </svg>
              </div>
              <div className="apexcharts-zoomout-icon" title="Zoom Out">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
                </svg>
              </div>
              <div
                className="apexcharts-zoom-icon apexcharts-selected"
                title="Selection Zoom"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#000000"
                  height={24}
                  viewBox="0 0 24 24"
                  width={24}
                >
                  <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                  <path d="M0 0h24v24H0V0z" fill="none" />
                  <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z" />
                </svg>
              </div>
              <div className="apexcharts-pan-icon" title="Panning">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  fill="#000000"
                  height={24}
                  viewBox="0 0 24 24"
                  width={24}
                >
                  <defs>
                    <path d="M0 0h24v24H0z" id="a" />
                  </defs>
                  <clipPath id="b">
                    <use overflow="visible" xlinkHref="#a" />
                  </clipPath>
                  <path
                    clipPath="url(#b)"
                    d="M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"
                  />
                </svg>
              </div>
              <div className="apexcharts-reset-icon" title="Reset Zoom">
                <svg
                  fill="#000000"
                  height={24}
                  viewBox="0 0 24 24"
                  width={24}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
                  <path d="M0 0h24v24H0z" fill="none" />
                </svg>
              </div>
              <div className="apexcharts-menu-icon" title="Menu">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                >
                  <path fill="none" d="M0 0h24v24H0V0z" />
                  <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
                </svg>
              </div>
              {/*<div className="apexcharts-menu">
                <div
                  className="apexcharts-menu-item exportSVG"
                  title="Download SVG"
                >
                  Download SVG
                </div>
                <div
                  className="apexcharts-menu-item exportPNG"
                  title="Download PNG"
                >
                  Download PNG
                </div>
                <div
                  className="apexcharts-menu-item exportCSV"
                  title="Download CSV"
                >
                  Download CSV
                </div>
              </div>*/}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

  )
}

export default React.memo(ProfileViewGraph);
